import React from "react";
import SubscribeLogo from "../other-icons/SubscribeLogo";
import { getAuthStatus } from "../../helper/datalayer-utils";
import "./subscribe-btn.m.css";

const SubscribeBtn = (isVerificationPending) => {
  const handleClick = () => {
    if (window) {
      // if (isVerificationPending) {
      //   window.dispatchEvent(
      //     new CustomEvent("show-snackbar", { detail: { type: "info", message: "We are verifying your payment and subscription, the process may take a few minutes." } })
      //   );
      //   return;
      // }
      const { status, uuid } = getAuthStatus();
      const formattedStatus = status === "not_logged_in" ? "non_logged_in" : status;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "subscription_header_button_click",
        auth_status: formattedStatus,
        source: "PV_site",
        uuid: uuid
      });
    }

    const target = new URL("/subscribe?utm_source=pv_site&utm_medium=subscribe_button&utm_campaign=pv_subscription", window.location.origin);
    target.searchParams.set("redirect_url", `${window.location.pathname}${window.location.search}${window.location.hash}`);
    window.location.href = target.toString();
  };

  return (
    <button styleName="subscribe-btn" onClick={handleClick} aria-label="Subscribe">
      <SubscribeLogo />
      <span styleName="subscribe-text">ಚಂದಾದಾರರಾಗಿ</span>
    </button>
  );
};

export default SubscribeBtn;
